<template>
  <div>
    <!-- Table Top -->
    <div class="tbl_info mt0">
      <div class="total">총 <strong>{{attachFileList.length}}</strong> ({{ totalSize | convertToFileSizeFormat }})</div>
      <div class="btn_area">
        <button type="button" class="btn btn_border btn_s" :disabled="!checkedSome" @click="deleteSelectedFiles">삭제</button>
        <button type="button" class="btn btn_border btn_s" :disabled="!addable" @click="onSelectFile">파일 업로드</button>
        <div class="info" style="padding-left:10px;font-size: 14px;">
          * 최대 {{ attachRestrictionQuantity }}개 {{ attachRestrictionSize }}MB 제한
        </div>
      </div>
    </div>
    <!-- Table Header -->
    <div class="data_tbl_list">
      <table class="table1" style="width:912px">
        <thead>
          <tr>
            <th scope="col" style="width:32px" class="check_box">
              <ur-checkbox :checked="checkedSome" :checked-icon="selectAllCheckedIcon" @click="clickSelectAll"/>
            </th>
            <th scope="col" style="width:auto">파일 이름</th>
            <th scope="col" style="width:137px" class="tar">파일 크기</th>
          </tr>
        </thead>
      </table>
    </div>
    <!-- Table Body -->
    <div
      class="thumbnail_wrap"
      :class="{'imgbox-modal-drag':showModalImgBox}"
      @dragover="onDragOver"
    >
      <!-- Init -->
      <div class="data_tbl_list" v-show="!showModalImgBox && attachFileList.length === 0">
        <table class="table2" style="width:912px">
          <tbody>
            <tr>
              <td colspan="3" class="file_dragdrop_wrap">
                <div class="file_dragdrop_upload">
                  <p>파일을 이곳에 끌어놓아 업로드 하세요.</p>
                  <p>OR</p>
                  <button type="button" class="btn_txt" @click="onSelectFile">파일 선택</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Drag -->
      <div class="data_tbl_list" v-show="showModalImgBox" style="opacity:0.5;">
        <!-- File Upload -->
        <input
          ref="inputFileType"
          type="file"
          multiple
          accept="*"
          class="attach-file"
          align="left"
          title=""
          style="width:912px"
          @change="onFilesChange($event.target.name, $event.target.files)"
          @drop="onDrop"
          @dragleave="onDragLeave"
        >
        <table class="table2" style="width:912px">
          <tbody>
            <tr>
              <td colspan="3" class="file_dragdrop_wrap">
                <div class="file_dragdrop_upload">
                  <p class="txt_blue">파일을 이곳에 끌어놓아 업로드 하세요.</p>
                  <p>OR</p>
                  <button type="button" class="btn_txt_black">파일 선택</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- File List -->
      <div class="data_tbl_list" v-show="!showModalImgBox && attachFileList.length > 0" style="max-height: 226px; overflow-x: hidden; overflow-y: auto;">
        <table class="table2" style="width:912px">
          <tbody>
            <tr v-for="(itm, index) in attachFileList" :key="index">
              <td style="width:32px" class="check_box">
                <ur-checkbox v-model="itm.checkBoxChecked" @input="onCheckBoxInput"/>
              </td>
              <td style="width:auto">{{ itm.fileName }}</td>
              <td class="tar" style="width:137px">{{ itm.fileSize | convertToFileSizeFormat }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 스낵바 -->
    <ur-snackbar ref="snackbar" :duration="3000"/>
  </div>
</template>

<script>

export default {
  name: 'CMP_AID_00005',
  filters: {
    /**
     * 파일 사이즈를 KB, MB 단위로 계산해서 단위와 함께 반환함
     * @function convertToFileSizeFormat
     * @param {Number} size: 변환대상 숫자
     * @returns {String} "123.45 KB" or "6.78 MB"
     */
    convertToFileSizeFormat(value) {
      let unit = ''; // 'KB' or 'MB'
      let resultVal = 0;

      if (value === 0) {
        resultVal = 0;
        unit = 'KB';
      } else if (value < 1024) {
        // 1024 byte 이하이면 항상 1 KB
        resultVal = 1;
        unit = 'KB';
      } else if (value > 1024 * 1024) {
        resultVal = value / (1024 * 1024);
        unit = 'MB';
      } else {
        resultVal = value / (1024);
        unit = 'KB';
      }
      return `${utils.numberFormat(resultVal, 2)} ${unit}`;
    },
  },
  props: {
    attachRestrictionSize: { // 총 파일 사이즈 제한 크기. 단위 MB
      type: Number,
      default: 1,
    },
    attachRestrictionQuantity: { // 총 파일 제한 갯수
      type: Number,
      default: 1,
    },
    fileUploadExt: { // 업로드 가능 확장자
      type: String,
      default: '', // 업로드 가능 확장자를 지정해주지 않으면 제한 없이 업로드 가능
    },
  },
  data() {
    return {
      checkedAll: false, // 전체 선택 여부
      checkedSome: false, // 부분 선택 여부 -> 삭제 버튼 활성화
      attachFileList: [],
      showModalImgBox: false,
      addable: true,
    };
  },
  computed: {
    totalSize() {
      let sum = 0;
      utils.forEach(this.attachFileList, file => {
        sum += file.fileSize;
      });
      return sum;
    },
    selectAllCheckedIcon() {
      if (this.checkedAll) {
        return 'checked'; // 전체 선택
      }

      if (this.checkedSome) {
        return 'indeterminate'; // 부분 선택
      }

      return 'box'; // 전체 해제
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    /**
     * fdp-check 의 input event handler
     * 현재 용도는 전체 checkbox 의 checked 값을 결정하기 위한 용도
     * 넘어온 매개변수는 사용하지 않음
     * @function onCheckBoxInput
     * @param {None}
     * @returns {none}
     */
    onCheckBoxInput() {
      this.$forceUpdate();
      this.setCheckedAll();
    },
    // select all check box 클릭
    clickSelectAll() {
      if (this.attachFileList.length > 0) {
        if (this.checkedAll) { // 전체 선택 -> 해제
          this.checkedAll = false;
          this.checkedSome = false;
          this.attachFileList.forEach(itm => {
            itm.checkBoxChecked = false;
          });
        } else { // 부분 선택/해제-> 전체 선택
          this.checkedAll = true;
          this.checkedSome = true;
          this.attachFileList.forEach(itm => {
            itm.checkBoxChecked = true;
          });
        }
      }
    },
    /**
     * "전체" checkbox의 checked 를 결정하는 함수
     * 개별 파일을 check/uncheck 할 때마다, 파일을 추가/삭제할 때마다 필요
     * @function setCheckedAll
     * @returns {None}
     */
    setCheckedAll() {
      if (this.attachFileList.length === 0) {
        this.checkedAll = false;
      } else {
        this.checkedAll = this.attachFileList.every(itm => itm.checkBoxChecked);
        this.checkedSome = this.attachFileList.some(itm => itm.checkBoxChecked);
      }
    },
    /**
     * input type file의 click 이벤트를 발생시켜 file browser 창을 연다.
     *
     * @function onSelectFile
     * @return  none
     */
    onSelectFile() {
      this.$refs.inputFileType.click();
    },
    /**
     * input type file의 change 이벤트 핸들러
     * file browser 에서 파일을 선택한 순간 해당 파일 정보를 기존 파일 목록에 추가한다.
     *
     * @function onFilesChange
     * @param  {String} fileNm TODO : 이 파라미터는 삭제?
     * @param  {Array} fileList : 선택한 파일(들)
     * @return  {String}
     */
    onFilesChange(fileNm, fileList) {
      if (!this.checkIsRightFileType(fileList)) {
        this.showSnackbar('업로드할 수 없는 파일 형식입니다.');
        // 동일한 파일을 연속 선택시 change 이벤트가 발생하지 않는 문제 해결
        this.$refs.inputFileType.type = '';
        this.$refs.inputFileType.type = 'file';
        return false;
      }

      if (!this.checkIsUnderSizeLimit(fileList)) {
        this.showSnackbar('업로드할 수 있는 파일의 용량을 초과하였습니다.');
        // 동일한 파일을 연속 선택시 change 이벤트가 발생하지 않는 문제 해결
        this.$refs.inputFileType.type = '';
        this.$refs.inputFileType.type = 'file';
        return false;
      }

      if (this.attachFileList.length + fileList.length > this.attachRestrictionQuantity) {
        this.showSnackbar('업로드할 수 있는 파일의 개수를 초과하였습니다.');
        // 동일한 파일을 연속 선택시 change 이벤트가 발생하지 않는 문제 해결
        this.$refs.inputFileType.type = '';
        this.$refs.inputFileType.type = 'file';
        return false;
      }

      const that = this;
      // handle file changes
      for (let j = 0; j < fileList.length; j += 1) {
        let bDup = false;
        const _file = fileList[j];
        const _re = /^.+\.(\w*$)/;
        const _ext = _re.exec(_file.name);

        // 파일명 중복 확인
        for (let i = 0; i < that.attachFileList.length; i += 1) {
          if (_file.name === that.attachFileList[i].fileName) {
            bDup = true;
            that.attachFileList[i].fileName = _file.name;
            that.attachFileList[i].fileSize = _file.size;
            that.attachFileList[i].fileExtensionName = _ext.length > 1 ? _ext[1] : '';
            that.attachFileList[i].arrayalOrder = 'autoNumberingColumn';
            that.attachFileList[i].file = _file;
            that.attachFileList[i].realityFilePath = ''; // 명이 동일한 파일을 선택한 경우에 다시 올린다.
            that.attachFileList[i].fileUid = '';
            break;
          }
        }

        if (!bDup) {
          const emptyDataFieldsObj = that.getEmptyFileInfoObj();
          emptyDataFieldsObj.checkBoxChecked = false;
          emptyDataFieldsObj.fileName = _file.name;
          emptyDataFieldsObj.fileSize = _file.size;
          emptyDataFieldsObj.fileExtensionName = _ext.length > 1 ? _ext[1] : '';
          emptyDataFieldsObj.arrayalOrder = 'autoNumberingColumn';
          emptyDataFieldsObj.file = _file;
          emptyDataFieldsObj.fileUid = '';

          that.attachFileList.push(emptyDataFieldsObj);
          this.$forceUpdate();
        }
      }

      // 동일한 파일을 연속 선택시 change 이벤트가 발생하지 않는 문제 해결
      this.$refs.inputFileType.type = '';
      this.$refs.inputFileType.type = 'file';

      if (this.attachFileList.length >= this.attachRestrictionQuantity) {
        this.addable = false;
      }
    },
    showSnackbar(message) {
      this.$nextTick(() => {
        this.$refs.snackbar.show({ text: message });
      });
    },
    /**
     * 파일 확장자가 적합한 확장자인지 검사
     * @function checkIsRightFileType
     * @param {Array}
     * @returns {Boolean}
     */
    checkIsRightFileType(files) {
      let rtnVal = true;

      if (this.fileUploadExt !== '') {
        const _re = /^.+\.(\w*$)/; // 파일 확장자 추출용 정규표현식
        for (let i = 0; i < files.length; i += 1) {
          const reExec = _re.exec(files[i].name);
          if (utils.isEmpty(reExec)) {
            rtnVal = false;
            break;
          }
          if (this.fileUploadExt.indexOf(reExec[1].toLowerCase()) < 0) {
            rtnVal = false;
            break;
          }
        }
      }
      return rtnVal;
    },
    /**
     * 첨부 최대 용량을 넘었는지 check 하여 boolean을 반환
     * @function checkIsUnderSizeLimit
     * @param {Array} files
     * @returns {Boolean}
     */
    checkIsUnderSizeLimit(files) {
      let preAttachSize = 0;
      utils.forEach(files, file => {
        preAttachSize += file.size;
      });
      // eslint-disable-next-line
      return this.attachRestrictionSize === 0 || ((this.totalSize + preAttachSize) < this.attachRestrictionSize * 1024 * 1024);
    },
    /**
     * 비어있는 하나의 json object를 리턴한다.
     * dataFields 에 정의된 칼럼 정보 사용
     * @function getEmptyFileInfoObj
     * @return {Object}
     */
    getEmptyFileInfoObj() {
      return {
        checkBoxChecked: false,
        fileName: '',
        fileSize: '',
        fileExtensionName: '',
        arrayalOrder: 'autoNumberingColumn',
        file: '',
        fileUid: '',
      };
    },
    /**
     * 선택한 파일들을 삭제한다.
     * @function deleteSelectedFiles
     * @returns {none}
     */
    deleteSelectedFiles() {
      for (let i = this.attachFileList.length - 1; i >= 0; i--) {
        if (this.attachFileList[i].checkBoxChecked) {
          this.attachFileList.splice(i, 1);
        }
      }
      this.checkedSome = false;
      this.checkedAll = false;
      if (this.attachFileList.length < this.attachRestrictionQuantity) {
        this.addable = true;
      }
    },
    onDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
      this.showModalImgBox = true;
    },
    onDragLeave(e) {
      this.showModalImgBox = false;
    },
    onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      // if (navigator.userAgent.indexOf('Trident') > -1) { // IE11 이면
      const fileList = e.dataTransfer.files;
      if (fileList) {
        this.onFilesChange('', fileList);
      }
      // }
      this.showModalImgBox = false;
    },
  },
};

</script>
<style scoped>

/* ========== Button ========== */
button {border:0}
button[disabled] {border:0; border-radius: 2px; background-color: #f7f7f7; color:#a5a5a5;}
.btn {display:inline-block; font-size: 14px; text-align: center; border-radius:4px; white-space: nowrap; font-weight: 500;}
.btn + .btn {margin-left:4px}
.btn_border {border: 1px solid #8b9abc; background-color: #fff; color:#333;}
.btn_border:hover {background-color: #f7f7f7}
.btn_border:active,
.btn_border:focus {background-color: #eaeaea}
.btn_border:disabled {background-color: #fff; border: 1px solid #ccc; color: #a5a5a5;}
.btn_border.btn_s:disabled {border:1px solid #cccccc; background-color: #fff; color:#a5a5a5}
.btn_s {min-width:48px; height: 24px; line-height: 22px; padding: 0 8px; font-size: 12px; font-weight: 400; border-radius: 2px;}
.btn_txt {position:relative; display:inline-block; font-size: 14px; text-align: center; color: #516af4; margin-left: auto; background: transparent; padding: 0 2px;}
.btn_txt_black {position:relative; display:inline-block; font-size: 14px; text-align: center; color: #333; margin-left: auto; background: transparent; padding: 0 2px;}

/* ========== Table 상단 정보 ========== */
.tbl_info {display:-webkit-box; display:-ms-flexbox;display:flex;-webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; margin-top: 24px; margin-bottom: 16px; font-size: 0;}
.tbl_info .total {font-size: 14px;}
.tbl_info .total strong {color:#222; margin-left:4px}
.tbl_info .total + .btn_area {margin-right: auto; position: relative; padding-left: 8px; margin-left: 8px;}
.tbl_info .total + .btn_area:before {display: inline-block; content: '';  width: 1px; height: 9px; background-color: #a5a5a5; position: absolute; top: 50%; margin-top: -4px; left: 0;}
.tbl_info .total + .btn_area .btn_s {border-radius:2px}
.tbl_info .total + .btn_area.right {margin-right: 0; margin-left: auto}
.tbl_info .total + .btn_area.right:before {display:none}

/* ========== Data Table 목록 ========== */
.data_tbl_list table {border: 0}
.data_tbl_list thead {border-bottom: 1px solid #dee1eb}
.data_tbl_list th {font-size: 14px; color:#333;border: 0; border-top: 1px solid #656b7e; /*border-bottom: 1px solid #dee1eb;*/ padding: 11px 0 12px 16px; height:47px; background-color: #f8f9fd; vertical-align: middle;} 
.data_tbl_list th.on {z-index: 1; color: #516af4;}
.data_tbl_list td {font-size: 14px; color:#333; border: 0; border-bottom: 1px solid #eaeaea; padding: 8px 0 8px 16px; height:48px; word-wrap: break-word;}
.data_tbl_list td.tar,
.data_tbl_list th.tar {text-align: right; padding-left:8px; padding-right:8px}
.data_tbl_list td.check_box,
.data_tbl_list th.check_box {padding-top: 15px}

/* ================ 기타 ================ */
.thumbnail_wrap {height:226px;border:none}

.txt_blue {color: #516af4;}

.attach-file {
  opacity: 0;
  width: 90%;
  height: 100%;
  cursor: pointer;
  position: absolute;
}
</style>
